/* ==========================================================================
   IronGrip Co. — scripts propios (vanilla, sin librerias)
   Una funcion init por componente. Cada una comprueba si su elemento existe.
   ========================================================================== */

(function () {
  'use strict';

  // Este archivo se incluye desde cada seccion, asi que el navegador lo ejecuta
  // varias veces en la misma pagina. Sin este cerrojo se duplicarian los
  // observadores y los clics (la FAQ se abriria y cerraria sola).
  if (window.__igScriptsCargado) return;
  window.__igScriptsCargado = true;

  var reduceMotion =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* --- Animaciones de entrada ------------------------------------------- */

  function revelarLosQueYaSeVen() {
    // Red de seguridad: si el observador no ha llegado a dispararse (pestana en
    // segundo plano, prerenderizado, navegador raro...), nada debe quedarse
    // invisible. Revelamos a mano lo que ya esta dentro de la ventana.
    var pendientes = document.querySelectorAll('.ig-reveal:not(.is-visible)');
    var alto = window.innerHeight || document.documentElement.clientHeight;
    for (var i = 0; i < pendientes.length; i++) {
      var caja = pendientes[i].getBoundingClientRect();
      if (caja.top < alto && caja.bottom > 0) pendientes[i].classList.add('is-visible');
    }
  }

  function initReveals() {
    var elementos = document.querySelectorAll('.ig-reveal:not(.is-visible)');
    if (!elementos.length) return;

    if (reduceMotion || !('IntersectionObserver' in window)) {
      for (var i = 0; i < elementos.length; i++) elementos[i].classList.add('is-visible');
      return;
    }

    var observador = new IntersectionObserver(
      function (entradas) {
        entradas.forEach(function (entrada) {
          if (!entrada.isIntersecting) return;
          entrada.target.classList.add('is-visible');
          observador.unobserve(entrada.target);
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -60px 0px' }
    );

    for (var j = 0; j < elementos.length; j++) observador.observe(elementos[j]);

    window.setTimeout(revelarLosQueYaSeVen, 1200);
  }

  /* --- Cifras que cuentan ------------------------------------------------ */

  function initContadores() {
    var cifras = document.querySelectorAll('[data-ig-contador]');
    if (!cifras.length) return;

    function animar(el) {
      var destino = parseFloat(el.getAttribute('data-ig-contador'));
      if (isNaN(destino)) return;
      var decimales = (el.getAttribute('data-ig-decimales') || '0') | 0;
      var prefijo = el.getAttribute('data-ig-prefijo') || '';
      var sufijo = el.getAttribute('data-ig-sufijo') || '';
      var duracion = 1500;
      var inicio = null;

      function paso(ahora) {
        if (inicio === null) inicio = ahora;
        var t = Math.min((ahora - inicio) / duracion, 1);
        var suave = 1 - Math.pow(1 - t, 3);
        el.textContent = prefijo + (destino * suave).toFixed(decimales) + sufijo;
        if (t < 1) requestAnimationFrame(paso);
      }
      requestAnimationFrame(paso);
    }

    if (reduceMotion || !('IntersectionObserver' in window)) {
      for (var k = 0; k < cifras.length; k++) {
        var c = cifras[k];
        c.textContent =
          (c.getAttribute('data-ig-prefijo') || '') +
          parseFloat(c.getAttribute('data-ig-contador')).toFixed(
            (c.getAttribute('data-ig-decimales') || '0') | 0
          ) +
          (c.getAttribute('data-ig-sufijo') || '');
      }
      return;
    }

    var obs = new IntersectionObserver(
      function (entradas) {
        entradas.forEach(function (entrada) {
          if (!entrada.isIntersecting) return;
          animar(entrada.target);
          obs.unobserve(entrada.target);
        });
      },
      { threshold: 0.5 }
    );

    for (var m = 0; m < cifras.length; m++) obs.observe(cifras[m]);
  }

  /* --- Barra de anuncio rotativa ----------------------------------------- */

  function initAnuncio() {
    var barras = document.querySelectorAll('[data-ig-anuncio]');
    if (!barras.length) return;

    barras.forEach(function (barra) {
      if (barra.dataset.igListo) return;
      barra.dataset.igListo = '1';
      var items = barra.querySelectorAll('.ig-anuncio__item');
      if (items.length < 2) return;
      var velocidad = parseInt(barra.getAttribute('data-ig-anuncio'), 10) || 5000;
      var actual = 0;

      setInterval(function () {
        items[actual].classList.remove('is-activo');
        actual = (actual + 1) % items.length;
        items[actual].classList.add('is-activo');
      }, velocidad);
    });
  }

  /* --- FAQ desplegable --------------------------------------------------- */

  function initFaq() {
    var items = document.querySelectorAll('.ig-faq__item');
    if (!items.length) return;

    items.forEach(function (item) {
      if (item.dataset.igListo) return;
      item.dataset.igListo = '1';
      var boton = item.querySelector('.ig-faq__btn');
      var panel = item.querySelector('.ig-faq__panel');
      if (!boton || !panel) return;

      boton.addEventListener('click', function () {
        var abierto = item.classList.contains('is-abierto');

        if (abierto) {
          panel.style.height = panel.scrollHeight + 'px';
          // Reflow sincrono: mas fiable que requestAnimationFrame, que no se
          // ejecuta si la pestana esta en segundo plano.
          void panel.offsetHeight;
          panel.style.height = '0px';
          item.classList.remove('is-abierto');
          boton.setAttribute('aria-expanded', 'false');
        } else {
          panel.style.height = panel.scrollHeight + 'px';
          item.classList.add('is-abierto');
          boton.setAttribute('aria-expanded', 'true');
          window.setTimeout(function () {
            if (item.classList.contains('is-abierto')) panel.style.height = 'auto';
          }, 460);
        }
      });
    });
  }

  /* --- Galeria de producto ----------------------------------------------- */

  function initGaleria() {
    var galerias = document.querySelectorAll('[data-ig-galeria]');
    if (!galerias.length) return;

    galerias.forEach(function (galeria) {
      if (galeria.dataset.igListo) return;
      galeria.dataset.igListo = '1';
      var principal = galeria.querySelector('[data-ig-galeria-principal]');
      var minis = galeria.querySelectorAll('[data-ig-galeria-mini]');
      if (!principal || !minis.length) return;

      minis.forEach(function (mini) {
        mini.addEventListener('click', function () {
          var src = mini.getAttribute('data-ig-galeria-mini');
          if (!src) return;
          principal.src = src;
          var alt = mini.getAttribute('data-ig-alt');
          if (alt !== null) principal.alt = alt;
          minis.forEach(function (m) {
            m.classList.remove('is-activa');
          });
          mini.classList.add('is-activa');
        });
      });
    });
  }

  /* --- Selector de variantes (pagina de producto) ------------------------ */

  function initVariantes() {
    var formularios = document.querySelectorAll('[data-ig-variantes]');
    if (!formularios.length) return;

    formularios.forEach(function (bloque) {
      if (bloque.dataset.igListo) return;
      bloque.dataset.igListo = '1';
      var datos = bloque.querySelector('[data-ig-variantes-json]');
      var input = bloque.querySelector('[data-ig-variante-id]');
      var boton = bloque.querySelector('[data-ig-boton-comprar]');
      var precio = bloque.querySelector('[data-ig-precio]');
      var tachado = bloque.querySelector('[data-ig-precio-tachado]');
      var opciones = bloque.querySelectorAll('[data-ig-opcion]');
      if (!datos || !input || !opciones.length) return;

      var variantes;
      try {
        variantes = JSON.parse(datos.textContent);
      } catch (e) {
        return;
      }

      var textoComprar = boton ? boton.getAttribute('data-ig-texto-comprar') : '';
      var textoAgotado = boton ? boton.getAttribute('data-ig-texto-agotado') : '';

      function aplicar(id) {
        var variante = null;
        for (var i = 0; i < variantes.length; i++) {
          if (String(variantes[i].id) === String(id)) variante = variantes[i];
        }
        if (!variante) return;

        input.value = variante.id;

        if (precio) precio.textContent = variante.precio;
        if (tachado) {
          if (variante.tachado) {
            tachado.textContent = variante.tachado;
            tachado.hidden = false;
          } else {
            tachado.hidden = true;
          }
        }

        if (boton) {
          if (variante.disponible) {
            boton.disabled = false;
            boton.classList.remove('is-disabled');
            var s1 = boton.querySelector('span');
            if (s1) s1.textContent = textoComprar;
          } else {
            boton.disabled = true;
            boton.classList.add('is-disabled');
            var s2 = boton.querySelector('span');
            if (s2) s2.textContent = textoAgotado;
          }
        }

        opciones.forEach(function (op) {
          var radio = op.querySelector('input');
          op.classList.toggle('is-elegida', !!radio && radio.checked);
        });
      }

      opciones.forEach(function (op) {
        var radio = op.querySelector('input');
        if (!radio) return;
        radio.addEventListener('change', function () {
          aplicar(radio.value);
        });
        if (radio.checked) aplicar(radio.value);
      });
    });
  }

  /* --- Arranque ---------------------------------------------------------- */

  function arrancar() {
    initReveals();
    initContadores();
    initAnuncio();
    initFaq();
    initGaleria();
    initVariantes();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arrancar);
  } else {
    arrancar();
  }

  // El editor de Shopify recarga secciones sueltas: reinicializa lo necesario.
  document.addEventListener('shopify:section:load', arrancar);

  // Si la pagina se cargo con la pestana en segundo plano, el observador no se
  // dispara: al volver a ella, revelamos lo que ya deberia verse.
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) revelarLosQueYaSeVen();
  });
  window.addEventListener('pageshow', revelarLosQueYaSeVen);
})();
